module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("\n    我是首页\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.10.3.0@vue-loader/lib/template-compiler.js?id=data-v-53f28fdc!./~/.10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/index.vue
// module id = 95
// module chunks = 1